import { render, staticRenderFns } from "./VendorBoothPreview.vue?vue&type=template&id=73881d54&"
import script from "./VendorBoothPreview.vue?vue&type=script&lang=js&"
export * from "./VendorBoothPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports